import React from 'react';
import { InstagramIcon, MailIcon } from 'lucide-react';
import { pricing, site } from '../data/content';
export function Footer() {
  return <footer className="w-full bg-forest-900 text-cream-200" data-id="element-47" data-mp="3ggk6ap6ov1ww">
      <div className="mx-auto max-w-6xl px-5 lg:px-8" data-id="element-48" data-mp="32onjn0nshk7w">
        <div className="grid gap-8 border-b border-white/10 py-14 sm:grid-cols-2 lg:grid-cols-[1.2fr_1fr_1fr]" data-id="element-49" data-mp="32m1awxp5wyo3">
          <div data-id="element-50" data-mp="3uf0mr7ucs6s8">
            <div className="flex items-center gap-2.5" data-id="element-51" data-mp="3ueilfwsu32dg">
              <span className="flex h-8 w-8 items-center justify-center rounded-md bg-gold-500 font-display text-sm font-extrabold text-forest-900" data-id="element-52" data-mp="3ucxo5zf4x5bw">
                FT
              </span>
              <span className="font-display text-base font-extrabold text-cream-50" data-id="element-53" data-mp="3le2jirrqo3ap">
                {site.brand}
              </span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed" data-id="element-54" data-mp="29ynlrlrph7ej">
              Educación financiera práctica para ordenar tu dinero y empezar a
              ahorrar con los ingresos que ya tenés.
            </p>
            <p className="mt-4 text-sm font-medium text-cream-50" data-id="element-55" data-mp="3lalh7iesgbvj">
              {site.domain}
            </p>
          </div>

          <nav aria-label="Secciones" data-id="element-56" data-mp="3gc0ixoj3k29q">
            <h2 className="font-display text-[11px] font-bold uppercase tracking-[0.12em] text-gold-500" data-id="element-57" data-mp="3v7q2lg0t83ba">
              Secciones
            </h2>
            <ul className="mt-4 space-y-2.5 text-sm" data-id="element-58" data-mp="3q7u39u325022">
              <li data-id="element-59" data-mp="82qrxrmhzrt7">
                <a className="transition-colors duration-150 ease-out hover:text-cream-50" href="#dolores" data-id="element-60" data-mp="828lk264fx7k">
                  Antes y después
                </a>
              </li>
              <li data-id="element-61" data-mp="hsk2cpawm0vv">
                <a className="transition-colors duration-150 ease-out hover:text-cream-50" href="#contenido" data-id="element-62" data-mp="ht3axfenzcx8">
                  Qué incluye
                </a>
              </li>
              <li data-id="element-63" data-mp="qt8h5m84g59t">
                <a className="transition-colors duration-150 ease-out hover:text-cream-50" href="#bonos" data-id="element-64" data-mp="qsqfga2owyui">
                  Bonos de regalo
                </a>
              </li>
              <li data-id="element-65" data-mp="tvd0pv9a0bgq">
                <a className="transition-colors duration-150 ease-out hover:text-cream-50" href="#precio" data-id="element-66" data-mp="tvw8ij57pjh1">
                  Precio
                </a>
              </li>
              <li data-id="element-67" data-mp="13tansffeg27r">
                <a className="transition-colors duration-150 ease-out hover:text-cream-50" href="#preguntas" data-id="element-68" data-mp="13sr6n0xkphus">
                  Preguntas frecuentes
                </a>
              </li>
            </ul>
          </nav>

          <div data-id="element-69" data-mp="1ckkqoxcb9ap4">
            <h2 className="font-display text-[11px] font-bold uppercase tracking-[0.12em] text-gold-500" data-id="element-70" data-mp="1cl2qg3y6m71s">
              Contacto
            </h2>
            <ul className="mt-4 space-y-2.5 text-sm" data-id="element-71" data-mp="1mk1s32kj52fa">
              <li data-id="element-72" data-mp="1mkbmr3girxrb">
                <a href={site.instagramUrl} className="flex items-center gap-2 transition-colors duration-150 ease-out hover:text-cream-50" data-id="element-73" data-mp="1mhxq4q66ydhn">
                  <InstagramIcon className="h-4 w-4 text-gold-500" aria-hidden="true" data-id="element-74" data-mp="3od85zdkl26mi" />
                  {site.instagram}
                </a>
              </li>
              <li data-id="element-75" data-mp="2ag5d6l9xj2e0">
                <a href={`mailto:${site.email}`} className="flex items-start gap-2 break-all transition-colors duration-150 ease-out hover:text-cream-50" data-id="element-76" data-mp="2agopnmgt8ykn">
                  <MailIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold-500" aria-hidden="true" data-id="element-77" data-mp="21n1x057wgbfo" />
                  {site.email}
                </a>
              </li>
            </ul>
            <a href="#comprar" className="mt-6 inline-block rounded-md bg-gold-500 px-5 py-3 font-display text-xs font-extrabold uppercase tracking-wide text-forest-900 transition-colors duration-150 ease-out hover:bg-gold-400" data-id="element-78" data-mp="2tdg2pe5rehg9">
              Empezar — {pricing.price}
            </a>
          </div>
        </div>

        <p className="py-6 text-xs text-cream-300" data-id="element-79" data-mp="18xutertl8vnk">
          © {new Date().getFullYear()} {site.brand}. Producto digital. Los
          resultados dependen de la aplicación de cada persona.
        </p>
      </div>
    </footer>;
}